export default "__VITE_ASSET__CplkYFiW__"